const state = {
    sideBar: {
        home: {
            code: "home",
            name: "總覽",
            focus: false,
            children: [
                {
                    code: "all",
                    name: "全廠域",
                    focus: false,
                    disabled: false,
                    children: []
                },
                {
                    code: "factory1",
                    name: "橋頭廠",
                    focus: false,
                    disabled: false,
                    children: []
                },
                {
                    code: "factory2",
                    name: "梓官廠",
                    focus: false,
                    disabled: false,
                    children: []
                },
            ],
            other: {
                process: {
                    "all": { name: "全廠" },
                    "factory1": { name: "一廠" },
                    "factory2": { name: "二廠" }
                }
            }
        },
        elecboard: {
            code: "elecboard",
            name: "即時看板",
            focus: false,
            children: [
                {
                    code: "heading",
                    name: "打頭",
                    focus: false,
                    disabled: false,
                    children: [{ code: "heading1", name: "成一組", focus: false, disabled: false }, { code: "heading2", name: "成二組", focus: false, disabled: false }, { code: "heading4", name: "成四組", focus: false, disabled: false }, { code: "heading5", name: "成五組", focus: false, disabled: false }]
                },
                {
                    code: "thread-rolling",
                    name: "輾牙",
                    focus: false,
                    disabled: false,
                    children: [{ code: "thread-rolling1", name: "輾一組", focus: false, disabled: false }, { code: "thread-rolling2", name: "輾二組", focus: false, disabled: false }]
                },
                {
                    code: "heat-treatment",
                    name: "熱處理",
                    focus: false,
                    disabled: false,
                    children: [{ code: "heat-treatment1", name: "熱一組", focus: false, disabled: false }, { code: "heat-treatment2", name: "熱二組", focus: false, disabled: false }]
                },
                {
                    code: "package",
                    name: "包裝",
                    focus: false,
                    disabled: false,
                    children: []
                },
                {
                    code: "container-load",
                    name: "出貨",
                    focus: false,
                    disabled: false,
                    children: []
                }
            ],
            other: {
                process: {
                    "heading": {
                        name: "打頭",
                        group: {
                            "heading1": {
                                name: "成一組",
                                device: ["B06", "B07", "B10", "B12", "B46", "B47", "B48", "B50", "B51", "B52"],
                                user: [{ name: '于志明', position: '組長', image: '成一-于志明.jpg' }, { name: '陳晉華', position: '組長', image: '成一-陳晉華.jpg' }]
                            },
                            "heading2": {
                                name: "成二組",
                                device: ["B14", "B16", "B32", "B33", "B34", "B35", "B36", "B37", "B38", "B39", "B44", "B49", "B53", "B54", "B55", "B56", 'B57'],
                                user: [{ name: '邱連城', position: '組長', image: '成二-邱連城.jpg' }, { name: '廖進吉', position: '組長', image: '成二-廖進吉.jpg' }]
                            },
                            "heading4": {
                                name: "成四組",
                                device: ["F12", "F31", "F32", "F43", "F44", "F45", "F46", "F47", "F48", "F49", "F50", "B01", "B02", "B05", "B15", "B17", "B18", "B19", "B20", "B21"],
                                user: [{ name: '張文吉', position: '組長', image: '成四-張文吉.jpg' }]
                            },
                            "heading5": {
                                name: "成五組",
                                device: ["F03", "F04", "F05", "F06", "F07", "F08", "F09", "F10", "F11", "F13", "F14", "F15", "F16", "F17", "F33", "F34", "F35", "F36", "F37", "F38", "F39", "F40", "F41", "F42", "F51", "F52", "B29", "B30", "B45"],
                                user: [{ name: '蔡坤益', position: '組長', image: '成五-蔡坤益.jpg' }]
                            },
                        },
                    },
                    "thread-rolling": {
                        name: "輾牙",
                        group: {
                            "thread-rolling1": {
                                name: "輾一組",
                                device: ["R09", "T13", "T14", "T17", "T18", "T22", "T23", "T24", "T28", "T43", "T47", "T51", "T53", "T54", "T61", "T64", "T65", "T68", "T69", "T70", "T71", "T98", "T100", "T101", "T102", "T103"],
                                user: [{ name: '黃志華', position: '組長', image: '輾一-黃志華.jpg' }]
                            },
                            "thread-rolling2": {
                                name: "輾二組",
                                device: ["R01", "R02", "R03", "R04", "R05", "R06", "R08", "R10", "R11", "R16", "R17", "R18", "R19", "R20", "R21", "R22", "R23", "R24", "R25", "R26", "R27", "R28", "R29", "R30", "R31", "R32", "R33", "R34", "R35", "R36", "R37", "R38", "R39", "R40", "S04", "S05", "S06", "S43", "S49", "T01", "T09", "T11", "T99"],
                                user: [{ name: '賴培銘', position: '組長', image: '輾二-賴培銘.jpg' }]
                            }
                        },
                    },
                    "heat-treatment": {
                        name: "熱處理",
                        group: {
                            "heat-treatment1": {
                                name: "熱一組",
                                device: ["A", "B", "C", "D", "E"],
                                user: [{ name: '桃青龍', position: '領班', image: '早班領班-桃青龍.jpg', class: "morning" }, { name: '蔣文財', position: '組長', image: '晚班組長-蔣文財.png', class: "evening" }]
                            },
                            "heat-treatment2": {
                                name: "熱二組",
                                device: ["A2", "B2", "C2", "D2"],
                                user: [{ name: '李佳壕', position: '組長', image: '早班組長-李佳壕.jpg', class: "morning" }, { name: '王偉豊', position: '領班', image: '晚班領班-王偉豊.png', class: "evening" }, { name: '潘宏典', position: '領班', image: '晚班領班-潘宏典.png', class: "evening" }]
                            }
                        },
                    },
                    "package": {
                        name: "包裝",
                        device: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
                        user: []
                    },
                    "container-load": {
                        name: "出貨",
                        device: ["A1", "A2", "A3"],
                        user: [{ name: '黃泓澔', position: '課長', image: '裝櫃-黃泓浩.jpeg' }, { name: '黃順雨', position: '組員', image: '裝櫃-黃順雨.jpeg' }]
                    }
                }
            }
        },
        // machstatus: {
        //     code: "machstatus",
        //     name: "機台狀態",
        //     children: [],
        //     other: null
        // },
        yieldstatistics: {
            code: "yieldstatistics",
            name: "產量統計",
            focus: false,
            children: [],
            other: null
        },
        activation: {
            code: "activation",
            name: "稼動率",
            focus: false,
            children: [
                {
                    code: "activationlog",
                    name: "稼動率日誌",
                    focus: false,
                    disabled: false,
                    children: []
                },
                {
                    code: "activationstatistics",
                    name: "稼動率統計",
                    focus: false,
                    disabled: false,
                    children: []
                },
            ],
            other: {
                process: {
                    "activationlog": { name: "稼動率日誌" },
                    "activationstatistics": { name: "稼動率統計" }
                }
            }
        },
        operatelog: {
            code: "operatelog",
            name: "運轉日誌",
            focus: false,
            children: [],
            other: null
        },
        errorhistory: {
            code: "errorhistory",
            name: "異常統計",
            focus: false,
            children: [
                {
                    code: "maintainstatus",
                    name: "即時維修狀態",
                    focus: false,
                    disabled: false,
                    children: []
                },
                {
                    code: "maintainlog",
                    name: "維修履歷",
                    focus: false,
                    disabled: false,
                    children: []
                },
                {
                    code: "alarmhistory",
                    name: "警報履歷",
                    focus: false,
                    disabled: false,
                    children: []
                }
            ],
            other: {
                process: {
                    "maintainstatus": { name: "即時維修狀態" },
                    "maintainlog": { name: "維修履歷" },
                    "alarmhistory": { name: "警報履歷" }
                }
            }
        },
        workorderhistory: {
            code: "workorderhistory",
            name: "工單履歷",
            focus: false,
            children: [],
            other: null
        },
        ordermanagement: {
            code: "ordermanagement",
            name: "工單管理",
            focus: false,
            children: [
                {
                    code: "appdatachange",
                    name: "APP資料調整",
                    focus: false,
                    disabled: false,
                    children: [
                        {
                            code: "modorderrecord",
                            name: "修改完工回報",
                            focus: false,
                            disabled: false,
                            children: []
                        },
                        {
                            code: "addorderrecord",
                            name: "新增完工回報",
                            focus: false,
                            disabled: false,
                            children: []
                        }
                    ]
                },
                {
                    code: "manualrecord",
                    name: "人工處理紀錄",
                    focus: false,
                    disabled: false,
                    children: []
                }
            ],
            other: {
                process: {
                    modorderrecord: { name: "修改完工回報" },
                    addorderrecord: { name: "新增完工回報" },
                    manualrecord: { name: "人工處理紀錄" }
                }
            }
        },
        operation: {
            code: "operation",
            name: "營運模組",
            focus: false,
            children: [],
            other: null
        },
        wireinquire: {
            code: "wireinquire",
            name: "線材查詢",
            focus: false,
            children: [],
            other: null
        },
        heattreatmentinstant: {
            code: "heattreatmentinstant",
            name: "即時參數顯示",
            focus: false,
            children: [],
            other: null
        },
        pcreport: {
            code: "pcreport",
            name: "生管報表",
            focus: false,
            children: [],
            other: null
        },
        statisticstable: {
            code: "statisticstable",
            name: "統計報表",
            focus: false,
            children: [
                {
                    code: "heattreatmentinquire",
                    name: "歷史參數查詢",
                    focus: false,
                    disabled: false,
                    children: []
                },
                {
                    code: "heattreatmentanalysis",
                    name: "統計分析",
                    focus: false,
                    disabled: false,
                    children: []
                },
                {
                    code: "inspecttimeout",
                    name: "自主檢驗超時",
                    focus: false,
                    disabled: false,
                    children: []
                },
            ],
            other: {
                process: {
                    "heattreatmentinquire": { name: "歷史參數查詢" },
                    "heattreatmentanalysis": { name: "統計分析" },
                    "inspecttimeout": { name: "自主檢驗超時" }
                }
            }
        },
        // machmalfunction: {
        //     code: "machmalfunction",
        //     name: "機台故障",
        //     children: [],
        //     other: null
        // }
    },
    sideBarSelect: null,
    sideBarLeft: true
};
const getters = {
    get_sideBar: state => {
        return state.sideBar;
    },
    get_sideBarSelect: state => {
        return state.sideBarSelect;
    },
    get_sideBarLeft: state => {
        return state.sideBarLeft;
    }
};
const actions = {
    set_sideBarSelect(context, array) {
        context.commit("SET_SIDEBARSELECT", array);
    },
    set_sideBarLeft(context, value) {
        context.commit("SET_SIDEBARLEFT", value);
    }
};
const mutations = {
    SET_SIDEBARSELECT(state, array) {
        let page = array[0];
        if (page == 'elecboard') {
            let process = array[1];
            let group = array[2];
            if (group == undefined || group == 'package' || group == 'container-load') {
                let data = state.sideBar.elecboard.other.process;
                state.sideBarSelect = {
                    page: page,
                    process: {
                        id: process,
                        name: data[process].name
                    },
                    group: {
                        id: process,
                        name: data[process].name,
                        device: data[process].device,
                        user: data[process].user
                    },
                    change: Math.random()
                };
            } else {
                let data = state.sideBar.elecboard.other.process;
                state.sideBarSelect = {
                    page: page,
                    process: {
                        id: process,
                        name: data[process].name
                    },
                    group: {
                        id: group,
                        name: data[process].group[group].name,
                        device: data[process].group[group].device,
                        user: data[process].group[group].user
                    },
                    change: Math.random()
                };
            }
        } else if (page == 'activation' || page == 'errorhistory' || page == 'statisticstable') {
            let process = array[1];
            let data = state.sideBar[page].other.process;
            state.sideBarSelect = {
                page: page,
                process: data,
                processName: data[process].name,
                change: Math.random()
            }
        } else if (page == 'home') {
            let process = array[1];
            let data = state.sideBar.home.other.process;
            state.sideBarSelect = {
                page: page,
                process: data,
                processName: data[process].name,
                change: Math.random()
            }
        } else if (page == "ordermanagement") {
            let process = array[array.length - 1];
            let data = state.sideBar.ordermanagement.other.process;
            state.sideBarSelect = {
                page: page,
                process: data,
                processName: data[process].name,
                change: Math.random()
            };
        }
        console.log(state.sideBarSelect);
    },
    SET_SIDEBARLEFT(state, value) {
        state.sideBarLeft = value;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/sideBarTree.js